import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=1fdb981f&scoped=true&"
import script from "./finance.vue?vue&type=script&lang=js&"
export * from "./finance.vue?vue&type=script&lang=js&"
import style0 from "./finance.vue?vue&type=style&index=0&id=1fdb981f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb981f",
  null
  
)

export default component.exports